module.exports = __webpack_public_path__ + "static/media/not-authorized.0ac6340e.png";